import { Component, OnDestroy, OnInit } from '@angular/core';
import { CompaniesService } from '../../../services/companies.service';
import { ClientAdvisors } from '../../../models/client';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { Store } from '@ngxs/store';
import { ClientSelectionState } from '../../../state/ClientSelectionState/ClientSelection.state';

@Component({
  selector: 'lib-advisors-tile',
  templateUrl: './advisors-tile.component.html',
  styleUrls: ['./advisors-tile.component.scss'],
  standalone: false
})
export class AdvisorsTileComponent implements OnInit, OnDestroy {
  public advisors: ClientAdvisors[] = [];

  private destroy$ = new Subject<void>();
  constructor(
    private companyService: CompaniesService,
    private store: Store
  ) {}
  ngOnInit(): void {
    this.store
      .select(ClientSelectionState.clientCode)
      .pipe(
        takeUntil(this.destroy$),
        mergeMap(code => {
          if (code != null) {
            return this.companyService.getClientAdvisors(code);
          }
          return of([]);
        })
      )
      .subscribe(x => {
        this.advisors = x;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }
}
